// extracted by css-extract-rspack-plugin
module.exports =  {"singleSlider":"ni19I","textsize":"V9jqz","description":"UuT7Z"};